import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CatalogProductPincodePricingGroupService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/catalogProductPincodePricingGroup";

  searchCatalogProductPincodePricingGroup(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getCatalogProductPincodePricingGroup(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getCatalogProductPincodePricingGroupById(groupId: number): Observable<Object> {
    return this.http.get(`${this.url}/${groupId}`);
  }


  createCatalogProductPincodePricingGroup(catalogProductPincodePricingGroup: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, catalogProductPincodePricingGroup);
  }


  getAllCatalogProductPincodePricingGroupDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  deleteByCatalogProductPincodePricingGroupId(groupId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${groupId}`);
  }
}
